import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EnumsState } from './enums.types';

export const selectEnums = createFeatureSelector<EnumsState>('enums');

export const selectEnumItems = createSelector(selectEnums, enums => enums.items);
